export default __webpack_public_path__ + "static/media/blob-shape-1.2243721b.svg";